import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import SegmentMessage from "../../components/forms/messages/SegmentMessage.jsx";
import LoginForm from "../../components/sentry/LoginForm.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import { doLogin } from "../../state/reducers/authentication/authenticationActions.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

import { RESOURCE_KEYS, URL_ACTIONS } from "../../constants/entity.js";
import { ROUTES } from "../../constants/routing.js";

class Login extends PureComponent {
  static propTypes = {
    doLogin: PropTypes.func.isRequired,
    resetErrors: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const { section, action } = props.match.params;

    this.state = {
      showInviteMessage:
        section === RESOURCE_KEYS.INVITES && action === URL_ACTIONS.MANAGE
    };
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    this.props.resetErrors();
    this.props.doLogin(values.username, values.password);
  };

  // -- RENDER -- //

  renderMessage = copyKey => {
    const { copy } = this.props;

    return (
      <SegmentMessage
        title={copy(`${copyKey}.title`)}
        message={copy(`${copyKey}.message`)}
        className="sentry-form-message"
        info={true}
      />
    );
  };

  doManageCookies = () => {
    console.log("COOKIES!!!");
    Cookiebot.renew();
    console.log("COOKIES DONE!!!");
  };

  render() {
    const { copy } = this.props;
    const { showInviteMessage } = this.state;

    const copyKey = "sentry.login";

    return (
      <div className="sentry-form">
        <Header as="h3" inverted textAlign="center">
          {copy(`${copyKey}.title`)}
        </Header>
        {showInviteMessage && this.renderMessage(`${copyKey}.messages.invite`)}
        <ErrorBoundary>
          <LoginForm onSubmit={this.onSubmit} />
          <footer>
            <LinkWithReset to={ROUTES.PASSWORD_RESET}>
              {copy(`${copyKey}.password_recovery_cta`)}
            </LinkWithReset>
            {` | `}
            <LinkWithReset to={ROUTES.USERNAME_RECOVERY}>
              {copy(`${copyKey}.username_recovery_cta`)}
            </LinkWithReset>
            <br />
            <LinkWithReset to={ROUTES.SIGNUP}>
              {copy(`${copyKey}.sign_up_cta`)}
            </LinkWithReset>
            {` | `}
            <LinkWithReset to={ROUTES.FEDERATED_LOGIN_LINK}>
              {copy(`${copyKey}.login_federated_cta`)}
            </LinkWithReset>
            <br />
            <a onClick={this.doManageCookies}>
              {copy(`${copyKey}.cookie_consent`)}
            </a>
            {` | `}
            <a href="/cookies.html">{copy(`${copyKey}.cookie_policy`)}</a>
          </footer>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  doLogin: (username, password) => dispatch(doLogin(username, password)),
  resetErrors: () => dispatch(resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
